<template>
    <div class="audit-analytics-entity-discovered loading-container">
        <loading :active="updating" :is-full-page="false" />
        <div class="task-body">
            <h2
                v-dialog="
                    'A new Pledged Security row was discovered with a person identifier that has not previously been matched to an Executive on the platform. One of the following executives may be a match based on the name information.'
                "
            >
                Audit Analytics Entity Discovered
            </h2>

            <h4>Pledged Security</h4>

            <dl>
                <dt>Name</dt>
                <dd>
                    {{ security.personFullName }}
                </dd>
                <dt>Company</dt>
                <dd>
                    {{ company.name }} <span v-if="company.symbol">({{ company.symbol }})</span>
                </dd>
                <dt>Effective Date</dt>
                <dd>{{ iso8601Date(security.effectiveDate) }}</dd>
                <dt>File Date</dt>
                <dd>{{ iso8601Date(security.fileDate) }}</dd>
                <dt>Filing</dt>
                <dd>
                    <a :href="`https://www.sec.gov${security.httpFileName}`" class="primary-link" target="_blank">
                        Filing
                    </a>
                </dd>
            </dl>

            <h4>Candidate Executives</h4>

            <table class="mt-table">
                <tbody>
                    <tr v-for="executive in executives" :key="executive.id">
                        <td class="radio">
                            <input type="radio" v-model="selectedExecutive" :value="executive" />
                        </td>
                        <td>
                            <ExecutiveBadge :executive="executive" />
                            <div class="executive-full-name">
                                <div v-if="executive.fullName !== executive.colloquialName">
                                    <strong>Full name</strong>: {{ executive.fullName }}
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="task-actions">
            <button @click="ignore" class="danger">Ignore</button>
            <button @click="associateExecutive" class="primary" :disabled="!selectedExecutive">Associate</button>
        </div>
    </div>
</template>
<script setup>
import { request } from '@/utils/request'
import { iso8601Date } from '@/utils/format'
import EntityProviderIdService from '@/services/manage/entityProviderIdService'
import TaskService from '@/services/manage/taskService'
import ExecutiveBadge from '@/components/executives/executive-badge'
import Providers from '@/utils/providers'
import { computed, ref } from 'vue'
import { asyncComputed } from '@/utils/asyncComputed'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const committing = ref(false)
const selectedExecutive = ref(null)

const content = asyncComputed(() => request.get(`/api/manage/pledged-securities/${props.item.secondaryEntityId}`))

const company = computed(() => content.value?.company ?? {})
const executives = computed(() => content.value?.executives ?? [])
const updating = computed(() => content.updating ?? committing.value)
const security = computed(() => content.value?.pledgedSecurity ?? {})

async function associateExecutive() {
    committing.value = true

    const { ok, status } = await EntityProviderIdService.linkProvider(
        selectedExecutive.value.type,
        selectedExecutive.value.id,
        Providers.auditAnalytics.id,
        `${security.value.personId}`,
        null,
        null
    )

    if (ok || status === 409) {
        await TaskService.complete(props.item)
    }

    committing.value = false
}
async function ignore() {
    committing.value = true
    await TaskService.complete(props.item)
    committing.value = false
}
</script>
<style scoped>
h4 {
    margin: 16px 0 0;
}

.mt-table {
    margin-top: 8px;
}

ul {
    height: 1%;
    flex-grow: 1;
    overflow: auto;
    padding: 16px 16px 16px 0;
}

dl {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.executive-full-name {
    margin-top: 8px;
}
</style>
